import React, { useState, useEffect } from "react";
import DynamicBanner from "../Pages/include/DynamicBanner";
import api from "../../api";
import toast from "react-hot-toast";

export default function AlumniRegistrationForm() {
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submissionMessage, setSubmissionMessage] = useState(null);
    const [photoPreview, setPhotoPreview] = useState(null);
    const [formData, setFormData] = useState({
        alumni_name: '', dob: '', age: '', gender: '', nationality: '',
        medical_reg_no: '', degree_passing_year: '', blood_group: '',
        father_name: '', father_occupation: '', mother_name: '', mother_occupation: '',
        qualification_type: '', mobile: '', email: '', whatsapp_number: '', linkedin_fb: '',
        address_line: '', city: '', state: '', country: '',
        career_status: '', competitive_exams: '',
        passport_photo: null,
        consent: false
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get('/api/sitepages/alumni-admission-form');
                setPageData(response.data);
            } catch (err) {
                setError("Failed to load page configuration.");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, files, checked } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: type === 'file' ? files[0] : type === 'checkbox' ? checked : value,
        }));

        if (name === 'passport_photo' && files.length > 0) {
            setPhotoPreview(URL.createObjectURL(files[0]));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.consent) {
            toast.error("Please agree to the CARE Alumni membership terms.");
            return;
        }

        const data = new FormData();
        for (const key in formData) {
            if (key !== 'consent' && formData[key] !== null && formData[key] !== '') {
                data.append(key, formData[key]);
            }
        }

        try {
            const response = await api.post('/api/alumni-admission-form/submit', data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            toast.success(response.data.message || "Registration successful!");

            e.target.reset();
            setPhotoPreview(null);

            setFormData({
                alumni_name: '', dob: '', age: '', gender: '', nationality: '',
                medical_reg_no: '', degree_passing_year: '', blood_group: '',
                father_name: '', father_occupation: '', mother_name: '', mother_occupation: '',
                qualification_type: '', mobile: '', email: '', whatsapp_number: '', linkedin_fb: '',
                address_line: '', city: '', state: '', country: '',
                career_status: '', competitive_exams: '',
                passport_photo: null, consent: false
            });

        } catch (error) {

            if (error.response?.status === 422) {
                const errors = error.response.data.errors;
                Object.values(errors).forEach((errArr) => {
                    toast.error(errArr[0]);
                });
                return;
            }

            const msg = error.response?.data?.message || 'Submission failed. Please check your inputs.';
            toast.error(msg);
        }
    };

    if (loading) return null;
    if (error || !pageData) return null;

    const bannerData = pageData.banner_data;
    const formControl = pageData.form_control;

    const renderForm = () => (
        <div className="card shadow-lg">
            <div className="card-body p-4">

                {submissionMessage && (
                    <div className={`alert alert-${submissionMessage.type === 'success' ? 'success' : 'danger'} mb-4`}>
                        {submissionMessage.text}
                    </div>
                )}

                <h3 className="text-center mb-4 fw-bold">
                    CARE Alumni Membership Registration
                </h3>

                <form onSubmit={handleSubmit} encType="multipart/form-data">

                    <div className="mb-3">
                        <label className="form-label">
                            Alumni Name <span className="text-danger">*</span>
                        </label>

                        <input type="text" className="form-control" name="alumni_name" onChange={handleChange} required />
                    </div>

                    <div className="mb-3"
                        onClick={() => document.getElementById("dob").showPicker?.()}>
                        <label className="form-label">
                            Date of Birth <span className="text-danger">*</span>
                        </label>
                        <input id="dob" type="date" className="form-control" name="dob" onChange={handleChange} required />
                    </div>


                    <div className="mb-3">
                        <label className="form-label">Age</label>
                        <input type="number" className="form-control" name="age" min={18} max={150} onChange={handleChange} />
                    </div>

                    <div className="mb-3">
                        <label className="form-label d-block">Gender</label>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="gender" value="Male" onChange={handleChange} />
                            <label className="form-check-label">Male</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="gender" value="Female" onChange={handleChange} />
                            <label className="form-check-label">Female</label>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Nationality</label>
                        <input type="text" className="form-control" name="nationality" onChange={handleChange} />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Medical Council Reg.No (Doctors Only)</label>
                        <input type="text" className="form-control" name="medical_reg_no" onChange={handleChange} />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Name of Degree & Month/Year of Passing  <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="degree_passing_year" onChange={handleChange} required />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Blood Group</label>
                        <select className="form-select" name="blood_group" onChange={handleChange}>
                            <option value="">Select</option>
                            {["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-"].map((bg) => (<option key={bg} value={bg}>{bg}</option>))}
                        </select>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Father's Name</label>
                            <input type="text" className="form-control" name="father_name" onChange={handleChange} />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Father's Occupation</label>
                            <input type="text" className="form-control" name="father_occupation" onChange={handleChange} />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Mother's Name</label>
                            <input type="text" className="form-control" name="mother_name" onChange={handleChange} />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Mother's Occupation</label>
                            <input type="text" className="form-control" name="mother_occupation" onChange={handleChange} />
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="form-label d-block">Educational Qualification</label>
                        {["UG", "PG", "PhD"].map((q) => (
                            <div className="form-check form-check-inline" key={q}>
                                <input className="form-check-input" type="radio" name="qualification_type" value={q} onChange={handleChange} />
                                <label className="form-check-label">{q}</label>
                            </div>
                        ))}
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Mobile No  <span className="text-danger">*</span></label>
                            <input type="number" className="form-control" name="mobile" onChange={handleChange} required />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Email ID  <span className="text-danger">*</span></label>
                            <input type="email" className="form-control" name="email" onChange={handleChange} required />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">WhatsApp Number  <span className="text-danger">*</span></label>
                            <input type="number" className="form-control" name="whatsapp_number" onChange={handleChange} required />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">LinkedIn / Facebook ID</label>
                            <input type="url" className="form-control" name="linkedin_fb" onChange={handleChange} />
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Address for Communication</label>
                        <input type="text" className="form-control" name="address_line" onChange={handleChange} />
                    </div>

                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <label className="form-label">City</label>
                            <input type="text" className="form-control" name="city" onChange={handleChange} />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">State</label>
                            <input type="text" className="form-control" name="state" onChange={handleChange} />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Country</label>
                            <input type="text" className="form-control" name="country" onChange={handleChange} />
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="form-label d-block">Career Status</label>
                        {["Preparing for PG Entrance", "Employed", "Pursuing Post Graduation"].map((item) => (
                            <div className="form-check" key={item}>
                                <input className="form-check-input" type="radio" name="career_status" value={item} onChange={handleChange} />
                                <label className="form-check-label">{item}</label>
                            </div>
                        ))}
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Competitive Exams Cleared</label>
                        <select className="form-select" name="competitive_exams" onChange={handleChange}>
                            <option value="">Select</option>
                            {["TNPSC", "SSC", "UPSC", "AIPGEE", "PLAB", "USMLE", "IAS", "GATE", "CSIR", "UGC", "OTHERS"].map((exam) => (
                                <option key={exam} value={exam}>{exam}</option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Upload Passport Size Photo</label>
                        <input className="form-control" type="file" name="passport_photo" onChange={handleChange} accept="image/*" />
                        {photoPreview && (
                            <img src={photoPreview} alt="preview" className="img-thumbnail mt-3" style={{ width: "120px", height: "120px", objectFit: "cover" }} />
                        )}
                    </div>

                    <div className="form-check mb-4">
                        <input className="form-check-input" type="checkbox" id="consent" name="consent" onChange={handleChange} />
                        <label className="form-check-label" htmlFor="consent">
                            I agree to be a member of CARE Alumni
                        </label>
                    </div>

                    <button type="submit" className="btn btn-primary w-100 py-2 fs-5">
                        Submit
                    </button>

                </form>
            </div>
        </div>
    );

    const renderDisabledMessage = () => (
        <div className="container py-5">
            <div className="alert alert-warning text-center p-4">
                <h3>Registration Closed</h3>
                <p className="lead">{formControl.disabled_message || "Registrations are temporarily closed."}</p>
            </div>
        </div>
    );

    return (
        <>
            <DynamicBanner
                title={bannerData.title}
                bgImage={bannerData.desktop_images}
                bgImageMobile={bannerData.mobile_images}
            />
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        {formControl.is_active ? renderForm() : renderDisabledMessage()}
                    </div>
                </div>
            </div>
        </>
    );
}